module.exports = __webpack_public_path__ + "img/loading-v.2.f51e87e8.png";